import React, { useEffect, useRef, useState } from 'react'
import { Box, Card, IconButton, MenuItem, Tooltip } from '@mui/material'
import Input from '../../Common/ui/input'
import SelectInput from '../../Common/ui/selectInput'
import { Controller, useForm } from 'react-hook-form'
import DateInput from '../../Common/ui/dateInput'
import EditPencilIcon from '../../Common/Icon/EditPencilIcon'
import CreateRaciMatrixDialog from './CreateRaciMatrixDialog'
import { GrcTable, GrcTableContainer, GrcTableHead, GrcTableBody, GrcTableHeadRow, GrcTableRow, GrcTableCell } from '../../Common/ui/TableComponent'
// import { RadioGroup, RadioGroupItem } from '../../Common/ui/radio-group'
import { Checkbox } from '../../Common/ui/checkbox'
import { Tabs, TabsList, TabsTrigger } from '../../Common/ui/tabs'
import { Button } from '../../Common/ui/button'
import * as RoutePath from '../../Entities/RoutePath'
// import {
//     Select,
//     SelectItem,
//     SelectTrigger,
//     SelectValue,
//     SelectContent
// } from '../../Common/ui/select'
import { cn, inputValidation, MonthScheduler, roleColor } from '../../lib/utils'
import BinaryQuestionTable from './Components/BinaryQuestionTable'
import FormsQuestionTable from './Components/FormsQuestionTable'
import ThresholdLimitQuestions from './Components/ThresholdLimitQuestions'
import ChecklistQuestions from './Components/ChecklistQuestions'
import { useLocation, useNavigate, useParams } from 'react-router'
import { t } from 'i18next'
import {
    BINARY_QUESTION_KEY, CATEGORY_KEY, CHECKLIST_KEY, COMP_CONTROLINDEX, COMP_INACTIVE_DATE, COMPLIANCE_CATEGORY_KEY, COMPLIANCE_FOR_KEY, COMPLIANCE_STATUS, COMPLIANCE_TIMELINE_MANUAL, COMPLIANCE_TIMELINE_PREDIFINED
    // , complianceData
    , CONSULTED_INDEX_RACI, DESCRIPTION, FORMS_KEY, FREQUENCY_KEY, INFORMED_DEPARTMENT, INFORMED_INDEX_RACI, INFORMED_RACIID, INFORMED_ROLE, INTERNAL_CUT_OFF_KEY, MULTI_DEPARTMENTS_KEY, PERIOD_KEY, REGULATION_ID_KEY, SUB_CATEGORY_KEY, THRESHOLD_LIMIT_KEY
    , TIMELINE_KEY
} from 'src/Entities/Governance'
import { useGovernanceStore } from 'src/Containers/Onboarding/Store/GovernanceStore'
import { useCompStore } from './Store/ComplianceStore'
import { nanoid } from 'nanoid'
// import TimelineDialog from './TimelineDialog'
import { toast } from 'react-toastify'
import { useSettingsStore } from 'src/Containers/SettingsContainer/Store/Store'
import TimelineCalendar from 'src/Common/ui/TimelineCalendar'
import { LuCalendarClock } from 'react-icons/lu'
// import MultiSelectInputDisable from 'src/Common/ui/MultiSelectDisable'
import { useCommonStore } from 'src/Common/store/CommonStore'
import Loading from 'src/Common/ui/Loading'
import CustomTimelineDialog from './CustomTimelineDialog'
import { EVENT_BASED, EVENT_DATE, EVENT_DUE_FOR, week, WEEKLY } from 'src/Entities/ComplianceTypes'
import DatePickerInput from 'src/Common/ui/DatePickerInput'
import { ISO_CONVERT } from 'src/Entities/CommonEntities'
import { STATUS_ENUMS } from 'src/Entities/StatusEnums'
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

const AddCompliance = () => {
    const {
        getCompFor,
        getCompCategory,
        getCompSubCategory,
        getCompFrequency,
        createCompliance,
        GetComplianceById,
        compById,
        complianceCategory,
        complianceSubCategory,
        compFrequency,
        compLoadOverRide
    } = useCompStore()
    const complianceFor = useCompStore((state) => state.complianceFor)
    const { mandateType, regulationName } = useParams()
    const [compCategoryOptions, setCompCategoryOptions] = useState([])
    const [compSubCategoryOptions, setCompSubCategoryOptions] = useState([])
    const [compForOptions, setCompForOptions] = useState([])
    const [frequencies, setFrequencies] = useState([])
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const bodyType = queryParams.get('bodyType')
    const regulationId = queryParams.get('regulationId')
    const complianceId = queryParams.get('complianceId')
    const [raciiMatrices, setRaciiMatrices] = useState([])
    const [selectedValues, setSelectedValues] = useState()
    const orgId = localStorage.getItem('orgId')
    const [isDialogOpen, setIsDialogOpen] = useState(false)
    const [activeTab, setActiveTab] = useState(2)
    const [adError, setAdError] = useState(false)
    const formFileRef = useRef([])
    const navigate = useNavigate()
    const { getOrgRegulationData, getOrgRegulation, govLoadOverRide } = useGovernanceStore()
    const [regulatoryOptions, setRegulatoryOptions] = useState([])
    const { getConfigurationBasedOrganization, configurationData } = useSettingsStore()
    const {
        getAllDepartmentByOrgId,
        departmentByOrgId
    } = useCommonStore()
    const [getDepartments, setGetDepartments] = useState([])
    useEffect(() => {
        if (departmentByOrgId.length > 0) {
            setGetDepartments(departmentByOrgId)
        }
    }, [departmentByOrgId])
    const [controls, setControls] = useState([
        // temproary commented
        // {
        //     controlName: 'Binary Questions',
        //     controlId: 1,
        //     isChecked: false
        // },

        {
            controlName: 'Forms',
            controlId: 2,
            isChecked: true
        },
        // temproary commented
        // {
        //     controlName: 'Threshold Limits',
        //     Uod: [{ value: '%', label: 'Percentage', limit: 100 }],
        //     controlId: 3,
        //     isChecked: false
        // },

        {
            controlName: 'Checklist',
            controlId: 4,
            isChecked: false
        }
    ])

    const { control, formState: { errors, isSubmitting, isLoading }, clearErrors, register, setError, reset, setValue, trigger, handleSubmit } = useForm({
        mode: 'onChange',
        defaultValues: {
            actions: 1,
            category: selectedValues?.complainceCategory,
            frequency: 'month',
            description: selectedValues?.description
        }
    })
    const userId = localStorage.getItem('userId')
    const selectedValue = {
        organizationId: 0,
        regulationId: 0,
        complainceFor: 1,
        complainceCategory: 1,
        subCategory: 1,
        deparments: [],
        description: '',
        status: 1,
        inActiveDate: null,
        eventDate: null,
        EventDueFor: null,
        raciiMatrices: [
        ],
        complainceTimeline:
        {
            action: 1,
            frequency: 1,
            timeLine: '',
            internalCutoff: '',
            period: ''
        },
        complianceDueByMonths:
            [

            ],
        complainceControlIndex: [
            { controlId: 2, index: 1 }
        ],
        binaryQuestions: [
            // {
            //     question: '',
            //     questionUID: 'a0',
            //     connections: [
            //         {
            //             response: true,
            //             questionUID: '',
            //             action: 0,
            //             hieID: ''
            //         },
            //         {
            //             response: true,
            //             questionUID: '',
            //             action: 0,
            //             hieID: ''
            //         }
            //     ]
            // }
        ],
        forms: [
            // {
            //     FileStoreId: null,
            //     documentName: '',
            //     hyperLink: '',
            //     submitTo: '',
            //     penaltiesandFine: '',
            //     damageToReputation: ''
            // }
        ],
        thresholdLimits: [
            // {
            //     uom: 1,
            //     type: '',
            //     applicableLimitMin: 0,
            //     applicableLimitMax: 0,
            //     regulatoryLimitMin: 0,
            //     regulatoryLimitMax: 0,
            //     penaltyandFine: '',
            //     damageToReputation: ''
            // }
        ],
        checkLIst: [
            // {
            //     complainceId: 0,
            //     actions: '',
            //     penaltyAndFines: '',
            //     damageToReputation: ''
            // }
        ]
    }
    const isAdmin = true
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        const fetchData = async () => {
            compLoadOverRide(true)
            govLoadOverRide(true)
            try {
                setLoading(true)
                await Promise.all([
                    getCompFor(),
                    getCompCategory(),
                    getCompSubCategory(),
                    getCompFrequency(),
                    getAllDepartmentByOrgId(orgId),
                    getOrgRegulation(orgId, userId, bodyType),
                    getConfigurationBasedOrganization(orgId),
                    GetComplianceById(complianceId, isAdmin, userId)

                ])
            } catch (error) {
                console.error('Error fetching data:', error)
            } finally {
                compLoadOverRide(false)
                govLoadOverRide(false)
                setLoading(false)
            }
        }

        fetchData()
    }, [])

    useEffect(() => {
        if (complianceFor?.length > 0) {
            setCompForOptions(complianceFor.map((item) => {
                return {
                    value: item.id, label: item.name
                }
            }))
        }
    }, [complianceFor?.length])
    useEffect(() => {
        if (complianceCategory?.length > 0) {
            setCompCategoryOptions(complianceCategory.map((item) => {
                return {
                    value: item.id, label: item.name
                }
            }))
        }
    }, [complianceCategory?.length])
    useEffect(() => {
        if (complianceSubCategory?.length > 0) {
            setCompSubCategoryOptions(complianceSubCategory.map((item) => {
                return {
                    value: item.id, label: item.name
                }
            }))
        }
    }, [complianceSubCategory?.length])
    useEffect(() => {
        if (compFrequency?.length > 0) {
            setFrequencies(compFrequency.map((item) => {
                return {
                    value: item.id, label: item.name
                }
            }))
        }
    }, [compFrequency?.length])

    const onTabValueChange = value => {
        setActiveTab(value)
    }
    const [tempRaciMatrix, setTempRaciMatrix] = useState([])
    const raciModifier = (data) => {
        const matrices = JSON.parse(JSON.stringify(data.raciiMatrices || []))
        for (let i = 1; i <= 4; i++) {
            const find = data.raciiMatrices?.find(ele => ele.raciId === i)
            if (!find) {
                matrices?.splice(i - 1, 0,
                    {
                        department: i === INFORMED_RACIID ? INFORMED_DEPARTMENT[0].label : 'nodata',
                        departmentId: i === INFORMED_RACIID ? INFORMED_DEPARTMENT[0].value : null,
                        orgRegulationId: data.id,
                        organizationId: data.organizationId,
                        orgId: data.organizationId,
                        profilePic: null,
                        raciId: i,
                        role: i === INFORMED_RACIID ? INFORMED_ROLE[0].label : null,
                        roleId: i === INFORMED_RACIID ? INFORMED_ROLE[0].value : null,
                        status: null,
                        user: null,
                        userId: null
                    }
                )
            }
        }
        setTempRaciMatrix(matrices.sort((a, b) => a.raciId - b.raciId))
        setRaciiMatrices(matrices.sort((a, b) => a.raciId - b.raciId))
    }
    useEffect(() => {
        if (getOrgRegulationData.length > 0) {
            if (complianceId === 'create') {
                const des = getOrgRegulationData.find((item) => +item.regulationId === +regulationId)
                raciModifier(des)
                if (configurationData?.length > 0) {
                    const updateList = selectedValue?.complainceTimeline
                    updateList.internalCutoff = configurationData?.find(element => element.titleName === 'Monthly')?.values
                    updateList.period = configurationData?.find(element => element.subtitleName === 'Start Month')?.values
                    setSelectedValues({ ...selectedValue, raciiMatrices: des?.raciiMatrices, complianceDueByMonths: MonthScheduler(updateList.period, 1, 0, null, 1), complainceTimeline: updateList, organizationId: +orgId, regulationId: des?.regulationId })
                } else {
                    setSelectedValues({ ...selectedValue, raciiMatrices: des?.raciiMatrices, organizationId: +orgId, regulationId: des?.regulationId })
                }

                reset({
                    title: selectedValue.title,
                    description: selectedValue.description,
                    category: 1,
                    complianceFor: selectedValue.complainceFor,
                    complainceCategory: selectedValue.complainceCategory,
                    subCategory: selectedValue.subCategory,
                    'breif-description': selectedValue.description,
                    'complainceTimeline-action': selectedValue.complainceTimeline?.action,
                    timeLine: selectedValue.complainceTimeline?.timeLine,
                    internalCutOf: selectedValue.complainceTimeline?.internalCutoff,
                    deparments: selectedValue.deparments
                })
                setRegulatoryOptions(getOrgRegulationData)
            } else {
                setRegulatoryOptions(getOrgRegulationData)
            }
        }
    }, [getOrgRegulationData.length, complianceId, configurationData.length])
    useEffect(() => {
        if (compById?.organizationId && complianceId !== 'create') {
            if (compById?.complianceStatus === STATUS_ENUMS.Draft) {
                const complianceTimlineData = compById?.complainceTimeline
                compById.complianceDueByMonths = MonthScheduler(complianceTimlineData.period, complianceTimlineData.frequency, 0, null, complianceTimlineData?.timeLine)
            }
            setSelectedValues(compById)
            raciModifier(compById)
            setControls(controls.map((item) => {
                const find = compById.complainceControlIndex.find((ele) => +ele.controlId === +item.controlId)
                if (find) {
                    return { ...item, isChecked: true }
                }
                return item
            }))
            reset({
                title: compById.title,
                description: compById.description,
                category: 1,
                complianceFor: compById.complainceFor,
                complainceCategory: compById.complainceCategory,
                subCategory: compById.subCategory,
                'breif-description': compById.description,
                'complainceTimeline-action': compById.complainceTimeline?.action,
                timeLine: compById.complainceTimeline?.timeLine,
                internalCutOf: compById.complainceTimeline?.internalCutoff,
                period: compById.complainceTimeline?.period,
                deparments: compById.deparments
            })
            compById.binaryQuestions.forEach((item, i) => {
                setValue(`binaryQuestions-question-${i}`, item.question)
                item.connections.forEach((ele, j) => {
                    setValue(`binaryOption-${j === 0 ? 'yes' : 'no'}-${i}-${j}`, ele.action !== 0 ? ele.action : ele.hieID)
                })
            })
            compById.forms.forEach((ele, i) => {
                Object.keys(ele).forEach((item) => {
                    setValue(`forms-${item}-${i}`, ele[item])
                })
            })
            compById.thresholdLimits.forEach((ele, i) => {
                Object.keys(ele).forEach((item) => {
                    setValue(`thresholdLimits-${item}-${i}`, ele[item])
                })
            })
            compById.checkLIst.forEach((ele, i) => {
                Object.keys(ele).forEach((item) => {
                    setValue(`checkLIst-${item}-${i}`, ele[item])
                })
            })
            setActiveTab(compById.complainceControlIndex[0].controlId)
        }
    }, [compById?.organizationId])
    // eslint-disable-next-line no-unused-vars

    // useEffect(() => {
    //     if (configurationData?.length > 0 && configurationData[0]?.values && selectedValues) {
    //         const updateList = selectedValues?.complainceTimeline
    //         updateList.internalCutoff = configurationData.find(element => element.titleName === 'Monthly')?.values
    //         setSelectedValues({ ...selectedValues, complainceTimeline: updateList })
    //         setValue('internalCutOf', configurationData.find(element => element.titleName === 'Monthly')?.values)
    //     }
    // }, [configurationData.length])

    const handleAddControls = (type) => {
        let data
        const id = nanoid(6)
        checkTablebody()
        switch (type) {
            case BINARY_QUESTION_KEY:
                data = {
                    question: '',
                    questionUID: id,
                    connections: [
                        {
                            response: true,
                            questionUID: id,
                            action: 0,
                            hieID: ''
                        },
                        {
                            response: true,
                            questionUID: id,
                            action: 0,
                            hieID: ''
                        }
                    ]
                }
                break
            case FORMS_KEY:
                data = {
                    fileStoreId: 0,
                    documentName: '',
                    hyperLink: '',
                    submitTo: '',
                    penaltiesandFine: '',
                    damageToReputation: ''
                }
                break
            case THRESHOLD_LIMIT_KEY:
                data = {
                    uom: 1,
                    type: '',
                    applicableLimitMin: 0,
                    applicableLimitMax: 0,
                    regulatoryLimitMin: 0,
                    regulatoryLimitMax: 0,
                    penaltyandFine: '',
                    damageToReputation: ''
                }
                break
            case CHECKLIST_KEY:
                data = {
                    complianceId: 0,
                    actions: '',
                    taskOnDue: selectedValues?.complainceTimeline?.timeLine
                    // penaltyAndFines: '',
                    // damageToReputation: ''
                }
                break
            default:
                break
        }
        setSelectedValues(prevState => ({
            ...prevState,
            [type]: [...prevState[type], data]
        }))
    }
    const handleDeleteControls = (type, index) => {
        let updatedList = []
        updatedList = selectedValues[type].filter((ele, j) => j !== index)
        setSelectedValues(prevState => ({
            ...prevState,
            [type]: updatedList
        }))
    }
    // const IOSSwitch = styled((props) => (
    //     <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    // ))(({ theme }) => ({
    //     width: 36,
    //     height: 20,
    //     padding: 0,
    //     '& .MuiSwitch-switchBase': {
    //         padding: 0,
    //         margin: 2,
    //         transitionDuration: '300ms',
    //         '&.Mui-checked': {
    //             transform: 'translateX(16px)',
    //             color: '#fff',
    //             '& + .MuiSwitch-track': { backgroundColor: theme.palette.mode === 'dark' ? '' : 'hsl(var(--primary))', opacity: 1, border: 0 },
    //             '&.Mui-disabled + .MuiSwitch-track': { opacity: 0.5 }
    //         },
    //         '&.Mui-focusVisible .MuiSwitch-thumb': { color: '#33cf4d', border: '6px solid #fff' },
    //         '&.Mui-disabled .MuiSwitch-thumb': { color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600] },
    //         '&.Mui-disabled + .MuiSwitch-track': { opacity: theme.palette.mode === 'light' ? 0.7 : 0.3 }
    //     },
    //     '& .MuiSwitch-thumb': { boxSizing: 'border-box', width: 16, height: 16 },
    //     '& .MuiSwitch-track': { borderRadius: 26 / 2, backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D', opacity: 1, transition: theme.transitions.create(['background-color'], { duration: 500 }) }
    // }))

    const onValueSelectChange = (value, name) => {
        switch (true) {
            case name.includes('complainceControlIndex'):
                {
                    let controlList = selectedValues.complainceControlIndex
                    const updatedControls = controls.map((item, i) => {
                        if (item.controlId === value.controlId) {
                            if (!item.isChecked) {
                                controlList.unshift({ controlId: value.controlId })
                                setActiveTab(item.controlId)
                            } else {
                                let tempIndex = 0
                                controlList = controlList.filter((el, i) => {
                                    if (el.controlId !== value.controlId) {
                                        tempIndex = i
                                        return el
                                    }
                                    return null
                                })
                                setActiveTab(selectedValues.complainceControlIndex[tempIndex]?.controlId)
                            }
                            return { ...item, isChecked: !item.isChecked }
                        }
                        return item
                    })
                    setControls(updatedControls)
                    setSelectedValues(prevState => ({
                        ...prevState,
                        complainceControlIndex: controlList.map((item, i) => {
                            return {
                                controlId: item.controlId,
                                index: i
                            }
                        })
                    }))
                }
                break
            case name.includes('binaryOption'):
                {
                    const ids = name.split('-')
                    const updatedList = selectedValues.binaryQuestions.map((item, i) => {
                        if (+ids[ids.length - 2] === i) {
                            if (value === 1 || value === 2) {
                                item.connections[+ids[ids.length - 1]].action = value
                                item.connections[+ids[ids.length - 1]].hieID = 0
                            } else {
                                item.connections[+ids[ids.length - 1]].action = 0
                                item.connections[+ids[ids.length - 1]].hieID = value
                            }
                        }
                        return item
                    })
                    setSelectedValues(prevState => ({
                        ...prevState,
                        binaryQuestions: updatedList
                    }))
                }
                break
            case name.includes('action'):
                {
                    const updateList = selectedValues.complainceTimeline

                    if (+value === 2) {
                        updateList.action = 2
                        updateList.timeline = 0
                        updateList.frequency = 0
                        updateList.internalCutoff = 0
                    } else {
                        updateList.action = 1
                        updateList.frequency = 1
                    }
                    setSelectedValues({ ...selectedValues, complainceTimeline: updateList })
                }
                break
            case name === 'frequency':
                {
                    const updateList = selectedValues?.complainceTimeline
                    updateList.frequency = value
                    updateList.internalCutoff = configurationData?.find(element => element.configurationTitleId === value)?.values
                    updateList.eventDate = value === EVENT_BASED ? new Date() : null
                    const period = configurationData?.find(element => element.subtitleName === 'Start Month')?.values
                    const previousDate = new Date()
                    previousDate.setMonth(previousDate.getMonth() - 1)
                    updateList.eventDueFor = value === EVENT_BASED ? previousDate : null
                    setSelectedValues({ ...selectedValues, complainceTimeline: updateList, complianceDueByMonths: MonthScheduler(period, updateList.frequency, 0, null, selectedValues.complainceTimeline?.timeLine || 1) })
                }
                break
            case name === 'period':
                {
                    const updateList = selectedValues.complainceTimeline
                    updateList.period = value
                    setSelectedValues({ ...selectedValues, complainceTimeline: updateList })
                }
                break

            case name.includes('uom'):
                {
                    const updatedList = selectedValues.thresholdLimits.map((item) => {
                        item.uom = value
                        return item
                    })
                    setSelectedValues(prevState => ({
                        ...prevState,
                        thresholdLimits: updatedList
                    }))
                }
                break
            case name === MULTI_DEPARTMENTS_KEY:
                setSelectedValues(prevState => ({
                    ...prevState,
                    [name]: getDepartments.map((item) => {
                        if (value.includes(item.id)) {
                            return {
                                id: item.id,
                                name: item.name
                            }
                        } else {
                            return null
                        }
                    }).filter(el => el)
                }))
                break
            default:
                setSelectedValues(prevState => ({
                    ...prevState,
                    [name]: value
                }))
                break
        }
    }

    const onInputChangeTextArea = (e, name) => {
        const [controlName, key, index] = name.split('-')
        const change = selectedValues[controlName].map((item, i) => {
            if (i === +index) {
                item[key] = e
            }
            return item
        })
        setSelectedValues(prevState => ({
            ...prevState,
            [controlName]: change
        }))
    }

    const handleDateChange = (date, name, index) => {
        setSelectedValues(prevState => ({
            ...prevState,
            [name]: prevState[name].map((item, i) => {
                if (i === +index) {
                    item.taskOnDue = date
                }
                return item
            })
        }))
    }
    const onInputChange = (e, name) => {
        if (name.includes(FORMS_KEY) || name.includes(THRESHOLD_LIMIT_KEY) || name.includes(CHECKLIST_KEY)) {
            name = name.split('-')
            const controlName = name[0]
            const key = name[1]
            const index = name[2]
            const change = selectedValues[controlName].map((item, i) => {
                if (i === +index) {
                    item[key] = e.target.value
                }
                return item
            })
            setSelectedValues(prevState => ({
                ...prevState,
                [controlName]: change
            }))
        } else if (name.includes('upload-documents')) {
            const index = +name.split('-')[2]
            setSelectedValues(prevState => {
                const controlL = prevState.controlList.map((item) => {
                    if (item.controlName === 'Forms') {
                        const form = new FormData()
                        form.append('files', e.target.files)
                        const file = Array.from(e.target.files)
                        item.Questions[index].documents = file
                    }
                    return item
                })
                return {
                    ...prevState,
                    controlList: controlL
                }
            })
        } else if (name === 'inActiveDate') {
            setSelectedValues(prevState => ({
                ...prevState,
                [name]: e
            }))
        } else if (name === 'description') {
            setSelectedValues(prevState => ({
                ...prevState,
                [name]: e.target.value
            }))
        } else if (name === TIMELINE_KEY) {
            if (/^\d*$/.test(e)) {
                const updateList = selectedValues?.complainceTimeline
                updateList[name] = e
                setSelectedValues({ ...selectedValues, complainceTimeline: updateList })
            }
        } else if (name === EVENT_DATE) {
            const updateList = selectedValues?.complainceTimeline
            const previousDate = new Date(e)
            previousDate.setMonth(previousDate.getMonth() - 1)
            updateList.eventDueFor = previousDate
            updateList[name] = e
            setSelectedValues({ ...selectedValues, complainceTimeline: updateList })
        } else {
            if (/^\d*$/.test(e.target?.value)) {
                const updateList = selectedValues?.complainceTimeline
                updateList[name] = e.target?.value
                setSelectedValues({ ...selectedValues, complainceTimeline: updateList })
            }
        }
    }

    // const onSwitchChange = (event) => {
    //     setSelectedValues(prevState => {
    //         return {
    //             ...prevState,
    //             status: prevState.status === 1 ? 2 : 1,
    //             inActiveDate: prevState.inActiveDate ? null : new Date()
    //         }
    //     })
    // }
    const handleEditClick = () => {
        setIsDialogOpen(true)
    }

    const handleSaveRaciMatrix = (data) => {
        setSelectedValues({
            ...selectedValues,
            raciiMatrices: data
        })
        setIsDialogOpen(false)
    }

    const routePath = '/GRC' + RoutePath.GOVERNANCE.COMPLIANCE + '-' + RoutePath.GOVERNANCE.SETUP

    const handleAddCompliance = (e) => {
        // Validate compliance timeline
        const timeline = selectedValues?.complainceTimeline
        const isEventBased = timeline?.frequency === EVENT_BASED
        if (!isEventBased && (!timeline?.timeLine || String(timeline.timeLine).trim() === '' || +timeline.timeLine === 0)) {
            toast.warning(<p>{t('Compliance Timeline is required')}</p>, { position: 'top-right', theme: 'light' })
            return
        }
        // Validate control index (at least one control must be selected)
        if (!checkMandatoryControl()) {
            toast.warning(<p>{t('Please select at least one Control')}</p>, { position: 'top-right', theme: 'light' })
            return
        }
        // Validate that each selected control has at least one row of data
        if (!checkTablebody(true)) {
            return
        }
        if (checkMandatoryFields(selectedValues.raciiMatrices) && checkMandatoryControl() && checkTablebody()) {
            const finalData = { ...selectedValues }
            const timelineData = selectedValues.complainceTimeline
            timelineData[EVENT_DATE] = timelineData?.frequency === EVENT_BASED ? ISO_CONVERT(timelineData[EVENT_DATE]) : null
            timelineData[EVENT_DUE_FOR] = timelineData?.frequency === EVENT_BASED ? ISO_CONVERT(timelineData[EVENT_DUE_FOR]) : null
            timelineData.internalCutoff = timelineData?.frequency !== EVENT_BASED ? configurationData?.find(element => element.configurationTitleId === timelineData?.frequency)?.values : timelineData?.internalCutoff
            timelineData.timeLine = timelineData?.frequency === EVENT_BASED ? selectedValues?.complianceTimeline?.eventDueFor : timelineData.timeLine
            finalData.complainceTimeline = timelineData
            const customMonths = customMonthData.map(ele => {
                delete ele.dueFor
                delete ele.dueDate
                return ele
            }).map(ele => {
                ele.id = selectedValues.complianceDueByMonths[0].id
                ele.complianceId = selectedValues.complianceDueByMonths[0].complianceId
                ele.complianceTimelineId = selectedValues.complianceDueByMonths[0].complianceTimelineId
                return ele
            })
            finalData.complianceDueByMonths = customMonths
            // console.log(finalData)
            // return 'helow'
            // // eslint-disable-next-line no-unreachable
            createCompliance(finalData, userId, selectedValues?.id)
                .then((res) => {
                    if (res?.data) {
                        toast.success(<p className="w-[100%] flex flex-row justify-evenly items-center">{t('Compliance details submitted successfully')}</p>, { position: 'top-right', theme: 'light' })
                        navigate(`${routePath}/${mandateType}/${regulationName}?bodyType=${bodyType}&regulation=1&status=${selectedValues?.status}&frequency=${selectedValues?.complainceTimeline?.frequency}&regulationId=${selectedValues.regulationId}`)
                    } else {
                        const warningMessage = res?.response?.data?.errors
                        if (Array.isArray(warningMessage) && warningMessage.length > 0) {
                            warningMessage.forEach((message) => { toast.warning(<p>{message}</p>, { position: 'top-right', theme: 'light' }) })
                        } else {
                            toast.warning(<p>{warningMessage}</p>, { position: 'top-right', theme: 'light' })
                        }
                    }
                })
                .catch((error) => {
                    const warningMessage = error?.response?.data?.errors
                    if (Array.isArray(warningMessage) && warningMessage.length > 0) {
                        warningMessage.forEach((message) => { toast.warning(<p>{message}</p>, { position: 'top-right', theme: 'light' }) })
                    } else {
                        toast.warning(<p>{warningMessage}</p>, { position: 'top-right', theme: 'light' })
                    }
                })
        }
    }
    const isFieldMandatory = (field) => {
        return field &&
            field?.department !== '' &&
            field?.role !== ''
    }

    const checkMandatoryFields = (data) => {
        return data.length > 0
            ? Array.from({ length: 4 }, () => null).map((item, j) => {
                const find = data.find((ele) => ele.raciId === j + 1)
                if (find) {
                    return find
                } else {
                    return null
                }
            }).every((item, i) => {
                if (i !== 2 && i !== 3) {
                    if (isFieldMandatory(item)) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return true
                }
            })
            : false
    }
    const timelineChooser = (timeline) => {
        switch (timeline) {
            case WEEKLY:
                return <SelectInput
                    required={selectedValues?.complainceTimeline?.action === COMPLIANCE_TIMELINE_MANUAL}
                    rules={selectedValues?.complainceTimeline?.action === COMPLIANCE_TIMELINE_MANUAL ? { required: t('This field is Required') } : {}}
                    control={control}
                    errors={errors}
                    name={TIMELINE_KEY}
                    className='!mt-0'
                    placeholder="Select"
                    onValueChange={(value) => onInputChange(value, TIMELINE_KEY)}
                    value={selectedValues?.complainceTimeline?.timeLine}
                    options={week}
                    readOnly={selectedValues?.complainceTimeline?.action === COMPLIANCE_TIMELINE_PREDIFINED}
                    errorShow={selectedValues?.complainceTimeline?.action === COMPLIANCE_TIMELINE_MANUAL}
                />
            default:
                return <TimelineCalendar
                    id={TIMELINE_KEY}
                    name={TIMELINE_KEY}
                    control={control}
                    frequency={selectedValues?.complainceTimeline?.frequency}
                    frequencyArray={frequencies}
                    rules={{ required: 'This field is required' }}
                    errors={errors}
                    value={selectedValues?.complainceTimeline?.timeLine}
                    setError={setError}
                    clearErrors={clearErrors}
                    onInputChange={onInputChange}
                />
        }
    }
    const checkMandatoryField = (data) => {
        return isFieldMandatory(data)
    }

    const checkMandatoryControl = () => {
        const find = controls.find((el) => el.isChecked === true)
        return find
    }
    const checkTablebody = (showToast = false) => {
        const array = [{ label: 'Binary questions', value: BINARY_QUESTION_KEY },
        { label: 'Forms', value: FORMS_KEY },
        { label: 'Threshold Limits', value: THRESHOLD_LIMIT_KEY },
        { label: 'Checklists', value: CHECKLIST_KEY }]
        const disMessage = []
        const advFind = selectedValues?.complainceControlIndex?.every((item) => {
            if (selectedValues[array[item.controlId - 1].value]?.length > 0) {
                return true
            }
            disMessage.push(array[item.controlId - 1].label)
            return false
        })
        if (showToast && !advFind) {
            disMessage.forEach((label) => toast.warning(<p>{t(`Please add at least one row for ${label}`)}</p>, { position: 'top-right', theme: 'light' }))
        }
        return advFind
    }
    const [timelineDialog, setTimelineDialog] = useState(false)
    const closeTimelineDialog = () => {
        setTimelineDialog(false)
    }
    const listMonths = [
        { label: 'Jan', value: 1 },
        { label: 'Feb', value: 2 },
        { label: 'Mar', value: 3 },
        { label: 'Apr', value: 4 },
        { label: 'May', value: 5 },
        { label: 'Jun', value: 6 },
        { label: 'Jul', value: 7 },
        { label: 'Aug', value: 8 },
        { label: 'Sep', value: 9 },
        { label: 'Oct', value: 10 },
        { label: 'Nov', value: 11 },
        { label: 'Dec', value: 12 }
    ]

    const minDate = new Date()
    minDate.setHours(0, 0, 0, 0)
    minDate.setDate(minDate.getDate() - 1)
    // const onDragEnd = (result) => {
    //     if (!result.destination) return
    //     const controlList = selectedValues.complainceControlIndex
    //     const items = Array.from(controlList)
    //     const [reorderedItem] = items.splice(result.source.index, 1)
    //     items.splice(result.destination.index, 0, reorderedItem)
    //     // setTasks(items)
    //     setSelectedValues(prevState => ({
    //         ...prevState,
    //         complainceControlIndex: items.map((item, i) => {
    //             return {
    //                 controlId: item.controlId,
    //                 index: i
    //             }
    //         })
    //     }))
    // }
    const [customMonthData, setCustomMonthData] = useState([])
    return (
        <div className='p-5'>
            <Loading isLoading={loading} />
            {/* <TimelineDialog isOpen={timelineDialog} handleClose={closeTimelineDialog} frequency={selectedValues?.complainceTimeline?.frequency || 1} cycle={selectedValues?.complainceTimeline?.period || 0} timeline={ selectedValues?.complainceTimeline?.timeLine || ''} period={selectedValues?.complainceTimeline?.period || 1} interCutOff={selectedValues?.complainceTimeline?.internalCutoff}/> */}
            <CustomTimelineDialog frequency={selectedValues?.complainceTimeline?.frequency} customMonthData={customMonthData} setCustomMonthData={setCustomMonthData} isOpen={timelineDialog} handleClose={closeTimelineDialog} data={selectedValues?.complianceDueByMonths} cycle={selectedValues?.complainceTimeline?.period || 0} timeline={selectedValues?.complainceTimeline?.timeLine || ''} interCutOff={selectedValues?.complainceTimeline?.internalCutoff} />
            <Card className='p-5 '>
                <Box sx={{ pr: 2, pt: 4, pb: 4, display: 'flex', alignItems: 'center' }}>
                    <p className='risk-content-title' style={{ margin: 0 }}>{t('General')}</p>
                    <div style={{ margin: '0px 1px 0px 10px', flex: 1, borderBottom: '2px solid hsl(var(--primary-foreground))' }}></div>
                </Box>
                <Box display="grid" gridTemplateColumns="repeat(4, 1fr)" gap={2}>
                    <Box gridColumn="span 1" sx={{ pb: 4 }}>
                        <Input
                            errors={errors}
                            control={control}
                            required
                            rules={{
                                validate: (value) => {
                                    return inputValidation(value, value?.length < 50, t('This field is required'), t('characters should be less than 50'))
                                }
                            }}
                            name='title'
                            label={t('Compliance Title')}
                            register={register}
                            placeholder={t('Enter Compliance Title')}
                            type="text"
                            value={selectedValues?.title}
                            onValueChange={(value) => onValueSelectChange(value?.target?.value, 'title')}
                        />
                    </Box>
                    <Box gridColumn="span 2" className='w-full'>
                        <Input
                            errors={errors}
                            control={control}
                            required
                            rules={{
                                validate: (value) => {
                                    return inputValidation(value, value?.length < 251, t('This field is required'), t('Characters should be less than 250'))
                                }
                            }}
                            name='breif-description'
                            label={t('Description')}
                            placeholder="Enter Description"
                            type="text"
                            onValueChange={(e) => onInputChange(e, DESCRIPTION)}
                            value={selectedValues?.description}
                            maxLength={250}
                        />
                    </Box>
                    <Box gridColumn="span 1">
                        <SelectInput
                            label={t('Regulation')}
                            control={control}
                            errors={errors}
                            name="description"
                            placeholder="Select"
                            onValueChange={(value) => onValueSelectChange(value, REGULATION_ID_KEY)}
                            value={selectedValues?.regulationId}
                            defaultValue={selectedValues?.regulationId}
                            options={regulatoryOptions?.map(ele => {
                                return {
                                    value: ele.regulationId,
                                    label: ele.regulation
                                }
                            })}
                            readOnly
                        />
                    </Box>
                </Box >
                <Box display="grid" gridTemplateColumns="repeat(4, 1fr)" gap={2}>
                    <Box gridColumn="span 1">
                        <SelectInput
                            label={t('Category')}
                            control={control}
                            errors={errors}
                            name="category"
                            placeholder="Select"
                            onValueChange={(value) => onValueSelectChange(value, CATEGORY_KEY)}
                            value={1}
                            defaultValue={1}
                            options={[{ label: 'Regulatory', value: 1 }]}
                            readOnly
                        />
                    </Box>
                    <Box gridColumn="span 1">
                        <SelectInput
                            label={'Compliance For'}
                            required
                            rules={{ required: t('This field is Required') }}
                            control={control}
                            errors={errors}
                            name="complianceFor"
                            placeholder="Select"
                            onValueChange={(value) => onValueSelectChange(value, COMPLIANCE_FOR_KEY)}
                            value={selectedValues?.complainceFor}
                            options={compForOptions}
                        />
                    </Box>
                    <Box gridColumn="span 1">
                        <SelectInput
                            label={t('Compliance Category')}
                            required
                            rules={{ required: t('This field is Required') }}
                            control={control}
                            errors={errors}
                            name="complainceCategory"
                            placeholder="Select"
                            onValueChange={(value) => onValueSelectChange(value, COMPLIANCE_CATEGORY_KEY)}
                            value={selectedValues?.complainceCategory}
                            options={compCategoryOptions}
                        />
                    </Box>
                    <Box gridColumn="span 1">
                        <SelectInput
                            label={t('Sub Category')}
                            required
                            rules={{ required: t('This field is Required') }}
                            control={control}
                            errors={errors}
                            name="subCategory"
                            placeholder="Select"
                            onValueChange={(value) => onValueSelectChange(value, SUB_CATEGORY_KEY)}
                            value={selectedValues?.subCategory}
                            options={compSubCategoryOptions}
                        />
                    </Box>
                </Box>
                <Box display="grid" gridTemplateColumns="repeat(4, 1fr)" gap={2} mt={2}>
                    {/* <Box gridColumn="span 1">
                        <div style={{ marginBottom: '2%' }}>
                            <MultiSelectInputDisable required rules={{
                                validate: value => {
                                    if (value.length > 0) {
                                        return true
                                    }
                                    return 'This field is required'
                                }
                            }} label={t('Department')} control={control} errors={errors} name="deparments" placeholder={t('Select Department')} defaultValue={selectedValues?.deparments?.map(ele => ele?.id)} value={selectedValues?.deparments?.map(ele => ele?.id)} options={getDepartments?.map((data) => ({ id: data?.id, value: data?.id, label: data?.name, status: data?.status }))}
                            onValueChange={(value) => {
                                onValueSelectChange(value, MULTI_DEPARTMENTS_KEY)
                                setValue('deparments', value, { shouldValidate: true })
                            }} />
                        </div>
                    </Box> */}
                    {/* <Box gridColumn="span 1"><p className='grc-label'>{t('Status')}</p>
                        <FormControlLabel style={{ marginTop: '7px' }}
                            control={<IOSSwitch sx={{ my: 2, ml: 2, mr: 1 }} checked={selectedValues?.inActiveDate === null} onChange={onSwitchChange} />}
                            label={!selectedValues?.inActiveDate ? 'Active' : 'In Active'}
                        />
                    </Box> */}
                    <Box display="grid" gridTemplateColumns="repeat(4, 1fr)" gap={2} mt={2}>
                        {!selectedValues?.inActiveDate
                            ? null
                            : (<><Controller name="actions"
                                rules={selectedValues?.status !== COMPLIANCE_STATUS ? { required: t('This field is Required') } : {}}
                                control={control}
                                errors={errors}
                                render={({ field: { onChange } }) => (<Box gridColumn="span 4">
                                    <DateInput
                                        label={t('In Active Date')}
                                        required
                                        name="selectedDate"
                                        className={'input-grc'}
                                        value={selectedValues?.inActiveDate}
                                        defaultValue={selectedValues?.inActiveDate}
                                        onValueChange={(e) => {
                                            const val = e
                                            onInputChange(val, COMP_INACTIVE_DATE)
                                            onChange(val)
                                        }}
                                        minDate={minDate}

                                    />
                                </Box>)}
                            />
                                {errors && <p className='grc-error-msg text-danger'>{errors && 'selectedDate' && errors.selectedDate?.message}</p>}
                            </>
                            )
                        }
                    </Box>
                </Box>
                <Box sx={{ pr: 2, pb: 4, display: 'flex', alignItems: 'center' }}>
                    <p className='risk-content-title' style={{ margin: 0 }}>{t('RACI Matrix')}</p>
                    <div style={{ margin: '0px 1px 0px 10px', flex: 1, borderBottom: '2px solid hsl(var(--primary-foreground))' }}></div>
                    <Tooltip title="Edit RACI" placement="right-start" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                        <IconButton onClick={handleEditClick}><EditPencilIcon /></IconButton></Tooltip>
                </Box>
                <GrcTableContainer className='!min-h-[100px]'>
                    <GrcTable>
                        <GrcTableHead>
                            <GrcTableHeadRow>
                                <GrcTableCell align='center' sx={{ fontSize: '17px' }}>{t('Responsible')}<span className='text-[red]'>*</span></GrcTableCell>
                                <GrcTableCell align='center' sx={{ fontSize: '17px' }}>{t('Accountable')}<span className='text-[red]'>*</span></GrcTableCell>
                                <GrcTableCell align='center' sx={{ fontSize: '17px' }}>{t('Consulted')}</GrcTableCell>
                                <GrcTableCell align='center' sx={{ fontSize: '17px' }}>{t('Informed')}</GrcTableCell>
                            </GrcTableHeadRow>
                        </GrcTableHead>
                        <GrcTableBody>
                            <GrcTableRow>
                                {
                                    Array.from({ length: 4 }, () => null).map((ele, j) => {
                                        const data = selectedValues?.raciiMatrices?.find((element) => element.raciId === j + 1)
                                        return (
                                            <>
                                                {
                                                    data
                                                        ? <GrcTableCell align='center' key={j}>
                                                            <div>
                                                                {!data.user && data.department && data.role && j !== 3
                                                                    ? <div className='flex justify-center gap-1'><img src='/Common/Icon/DangerIcon.svg' />Vacant</div>
                                                                    : !data.user
                                                                        ? (
                                                                            <div className='text-muted'>-</div>
                                                                        )
                                                                        : null}
                                                                <p className='text-muted !text-[16px] whitespace-nowrap'>{data?.user}</p>
                                                                {!data.user && j === INFORMED_INDEX_RACI ? null : <p style={{ color: roleColor(data?.role) }} className={cn('regulation-cell-third', '!text-[14px] mt-1 whitespace-nowrap')}>{data?.role}</p>}
                                                            </div>
                                                            {adError && !checkMandatoryField(data) && j !== CONSULTED_INDEX_RACI && j !== INFORMED_INDEX_RACI && <div className='grc-error-msg text-danger'>This field is required</div>}

                                                        </GrcTableCell>
                                                        : <GrcTableCell align='center'>
                                                            <div>
                                                                <div>-</div>
                                                                {adError && !checkMandatoryField(data) && j !== CONSULTED_INDEX_RACI && j !== INFORMED_INDEX_RACI && <div className='grc-error-msg text-danger'>This field is required</div>}
                                                            </div>
                                                        </GrcTableCell>
                                                }

                                            </>
                                        )
                                    })
                                }
                            </GrcTableRow>
                        </GrcTableBody>
                    </GrcTable>
                </GrcTableContainer>
                <Box sx={{ pr: 2, pt: 4, pb: 4, display: 'flex', alignItems: 'center' }}>
                    <p className='risk-content-title' style={{ margin: 0 }}>{t('Data Setup')}</p>
                    <div style={{ margin: '0px 1px 0px 10px', flex: 1, borderBottom: '2px solid hsl(var(--primary-foreground))' }}></div>
                </Box>
                <Box display="grid" gridTemplateColumns="1fr 1fr 1fr 0.7fr" style={{ height: '104px' }} gap={5}>
                    {/* <Box gridColumn="span 1">
                        <p className='risk-content-title' style={{ margin: 0 }}>{t('Actions')}<span className='text-[red]'>*</span></p>
                        <Controller name="complainceTimeline-action"
                            rules={{ required: t('This field is Required') }}
                            control={control}
                            errors={errors}
                            render={({ field: { onChange } }) => (
                                <RadioGroup className='flex space-x-6 mt-5' defaultValue={selectedValues?.complainceTimeline?.action} value={selectedValues?.complainceTimeline?.action} required={selectedValues?.complainceTimeline?.action === 1}
                                    onValueChange={(e) => {
                                        const value = e
                                        onValueSelectChange(value, 'complainceTimeline-action')
                                        onChange(value)
                                    }}>
                                    <div className='flex items-center space-x-2'>
                                        <RadioGroupItem value={1} />
                                        <label className='text-sm'>Manual</label>
                                    </div>
                                    <div className='flex items-center space-x-2'>
                                        <RadioGroupItem value={2} />
                                        <label className='text-sm'>Predefined</label>
                                    </div>
                                </RadioGroup>)} />
                        <p className='grc-error-msg text-danger'>{errors && 'complainceTimeline-action' && errors.actions?.message}</p>
                    </Box> */}
                    <Box gridColumn="span 1" >
                        <SelectInput
                            label={t('Frequency')}
                            required={selectedValues?.complainceTimeline?.action === COMPLIANCE_TIMELINE_MANUAL}
                            rules={selectedValues?.complainceTimeline?.action === COMPLIANCE_TIMELINE_MANUAL ? { required: t('This field is Required') } : {}}
                            control={control}
                            errors={errors}
                            name="frequency"
                            placeholder="Select"
                            onValueChange={(value) => onValueSelectChange(value, FREQUENCY_KEY)}
                            value={selectedValues?.complainceTimeline?.frequency}
                            options={frequencies}
                            readOnly={selectedValues?.complainceTimeline?.action === COMPLIANCE_TIMELINE_PREDIFINED}
                            errorShow={selectedValues?.complainceTimeline?.action === COMPLIANCE_TIMELINE_MANUAL}
                        />
                    </Box>
                    {selectedValues?.complainceTimeline?.frequency === EVENT_BASED
                        ? <>
                            <Box className='flex gap-10 w-full pt-1 ' gridColumn="span 1.5" >
                                {/* <div className='w-full'>

                                    <DatePickerInput
                                        name={'eventDate'}
                                        label={'Due For'}
                                        required
                                        className={'input-grc !px-3 gap-3 flex-grow'}
                                        value={selectedValues.eventDate || ''}
                                        errors={errors}
                                        control={control}
                                        // minDate={item?.startDate || ''}
                                        // maxDate={fromMaxDate}
                                        // name="selectedDate"
                                        onValueChange={(e) => {
                                            onValueSelectChange(e, 'eventDate')
                                        }}
                                    />
                                </div> */}
                                <div className='w-full'>
                                    <DatePickerInput
                                        name={'EventDueFor'}
                                        label={'Hard Target'}
                                        rules={{ required: false }}
                                        required
                                        className={'input-grc !px-3 gap-3 flex-grow'}
                                        value={selectedValues?.complainceTimeline?.eventDate || ''}
                                        errors={errors}
                                        control={control}
                                        // minDate={item?.startDate || ''}
                                        // maxDate={fromMaxDate}
                                        // name="selectedDate"
                                        onValueChange={(e) => {
                                            onInputChange(e, EVENT_DATE)
                                        }}
                                    />
                                </div>

                            </Box>
                        </>
                        : <Box gridColumn="span 1" style={{ transform: 'translateY(-5px)' }}>
                            <div className='flex items-center justify-between'>
                                <div className='grc-label'>{t('Timeline')}{selectedValues?.complainceTimeline?.action === COMPLIANCE_TIMELINE_MANUAL && <span className='text-[red]'>*</span>}</div>
                                <div onClick={() => { if (selectedValues?.complainceTimeline?.timeLine && selectedValues.complainceTimeline.frequency !== WEEKLY) { setTimelineDialog(true) } }}>
                                    <Tooltip title="View Timeline" className={selectedValues?.complainceTimeline?.timeLine && 'cursor-pointer'} placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                        {selectedValues?.complainceTimeline?.timeLine && selectedValues?.complainceTimeline?.frequency !== WEEKLY ? <img src='/Common/Icon/calenderIconGreen.svg' /> : <LuCalendarClock color='hsl(var(--grey))' size={25} />}
                                    </Tooltip></div>
                            </div>
                            <div className={cn('flex rounded-lg mt-[6px]'
                            )}>
                                {/* <div className='relative'>
                                <div className='absolute top-[6px] left-1 text-primary'>{selectedValues?.complainceTimeline?.period === 2 ? '-' : selectedValues?.complainceTimeline?.period === 1 ? '+' : ''}</div>

                                <Controller
                                    name={'timeline'}
                                    control={control}
                                    rules={selectedValues?.complainceTimeline?.action === COMPLIANCE_TIMELINE_MANUAL
                                        ? {
                                            validate: (value) => {
                                                const regexPhone = (value) => {
                                                    if (value >= 0 && value <= 100) {
                                                        return true
                                                    } else {
                                                        return false
                                                    }
                                                }
                                                if (!value) {
                                                    return t('required')
                                                } else if (!regexPhone(value)) {
                                                    return '0 - 100'
                                                }
                                            }
                                        }
                                        : {}}
                                    render={({ field: { onChange } }) => (
                                        <input
                                            type='text'
                                            id={TIMELINE_KEY}
                                            name={TIMELINE_KEY}
                                            className={cn(
                                                'input-grc !mt-0 flex  h-9 w-[45px] border-none !outline-none rounded-lg rounded-tr-none rounded-br-none bg-transparent !pl-4 py-3 text-sm transition-colors file:border-1 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:border-none focus-visible:outline-none focus-visible:ring-[1.5px] focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50',
                                                selectedValues?.complainceTimeline?.action === COMPLIANCE_TIMELINE_MANUAL && selectedValues?.complainceTimeline?.frequency ? '' : 'bg-popover'
                                            )}
                                            onChange={(e) => { onInputChange(e, TIMELINE_KEY); onChange(e.target.value) }}
                                            value={selectedValues?.complainceTimeline?.timeLine}
                                            defaultValue={selectedValues?.complainceTimeline?.timeLine}
                                            readOnly={selectedValues?.complainceTimeline?.action !== COMPLIANCE_TIMELINE_MANUAL || !selectedValues?.complainceTimeline?.frequency}
                                        />
                                    )}
                                />
                            </div> */}

                                {/* <TimelineCalendar /> */}
                                {timelineChooser(selectedValues?.complainceTimeline?.frequency)}

                            </div>

                            <div className='flex justify-start gap-2'>
                                <p className='grc-error-msg text-danger'>{selectedValues?.complainceTimeline?.action === COMPLIANCE_TIMELINE_MANUAL && errors && TIMELINE_KEY && errors.timeline?.message}</p>
                                <p className='grc-error-msg text-danger'>{selectedValues?.complainceTimeline?.action === COMPLIANCE_TIMELINE_MANUAL && errors && PERIOD_KEY && errors.period?.message}</p>
                            </div>

                        </Box>}
                    <Box gridColumn="span 1">
                        <div>
                            <div className='grc-label'>{`${frequencies?.find((findDt) => findDt?.value === selectedValues?.complainceTimeline?.frequency)?.label} Soft Target`}{selectedValues?.complainceTimeline?.action === COMPLIANCE_TIMELINE_MANUAL && <span className='text-[red]'>*</span>}</div>
                        </div>
                        <div className='flex rounded-lg mt-[10px] ring-[1.5px] ring-[hsl(var(--border))] shadow-sm'>
                            <Controller
                                name={'internalCutOf'}
                                control={control}
                                render={({ field: { onChange } }) => (
                                    <input
                                        type='text'
                                        id={'internalCutOff'}
                                        name={'internalCutOff'}
                                        disabled={selectedValues?.complainceTimeline?.frequency !== EVENT_BASED}
                                        className={cn(selectedValues?.complainceTimeline?.frequency !== EVENT_BASED && 'bg-transparent bg-popover disabled:cursor-not-allowed disabled:opacity-50',
                                            'input-grc !mt-0 flex h-9 w-[50px] rounded-lg rounded-tr-none rounded-br-none border-none px-3 py-3 text-sm transition-colors file:border-1 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:border-none focus-visible:outline-none focus-visible:ring-[1.5px] focus-visible:ring-primary  '
                                        )}
                                        onChange={(e) => { onInputChange(e, INTERNAL_CUT_OFF_KEY); onChange(e.target.value) }}
                                        value={selectedValues?.complainceTimeline?.internalCutoff}
                                        readOnly={selectedValues?.complainceTimeline?.frequency !== EVENT_BASED}
                                    />
                                )}
                            />
                            <div className={cn('w-full text-muted text-sm text-center whitespace-nowrap pt-2 read-only bg-popover'
                            )}>{'Days before the hard target'}</div>
                        </div>
                    </Box>
                    <Box gridColumn="span 1">
                        <div className='text-muted text-[1.15rem] font-semibold'>Assessment Cycle</div>
                        <div className='flex w-full rounded-lg mt-[7px] ring-[1.5px] ring-[hsl(var(--border))] shadow-sm'>
                            <div className={cn('text-muted w-full text-md text-center whitespace-nowrap px-1 py-2 read-only bg-popover'
                            )}>{listMonths[selectedValues?.complainceTimeline?.period - 1]?.label + ' - ' + listMonths[configurationData?.find(element => element.subtitleName === 'End Month')?.values - 1]?.label}</div
                            ></div>

                        {/* <div className='w-full'>
                            <SelectInput
                                placeholder="Select"
                                name={'period'}
                                control={control}
                                required
                                readOnly={true}
                                options={listMonths}
                                value={selectedValues?.complainceTimeline?.period}
                                className='relative'
                                defaultValue={selectedValues?.complainceTimeline?.period}
                                onValueChange={value => onValueSelectChange(value, PERIOD_KEY)} />
                        </div> */}
                    </Box>

                </Box>
                {/* Below comment is to see the error list to check the validation
                {Object.keys(errors).length > 0 && (
                    <div>
                        <h2>Missing or Invalid Fields:</h2>
                        <ul>
                            {Object.keys(errors).map((key, index) => (
                                <li key={index}>{key}{errors[key].message}</li>
                            ))}
                        </ul>
                    </div>
                )} */}
                <Box sx={{ pr: 2, pt: 4, pb: 4, display: 'flex', alignItems: 'center' }}>
                    <p className='risk-content-title' style={{ margin: 0 }}>{t('Controls')}<span className='text-[red]'>*</span></p>
                    <div style={{ margin: '0px 1px 0px 10px', flex: 1, borderBottom: '2px solid hsl(var(--primary-foreground))' }}></div>
                </Box>
                <div className='flex mb-3'>
                    {controls.map((item, index) => (
                        <div key={index} className="px-3 py-2">
                            <MenuItem disabled={item.controlId === 2} className='!m-0 !p-0'>
                                <Checkbox
                                    checked={item.isChecked}
                                    onCheckedChange={() => { onValueSelectChange(item, COMP_CONTROLINDEX) }}
                                />
                                <label className="regulation-list-items-label ml-2">
                                    {item?.controlName}
                                </label>
                            </MenuItem>
                        </div>
                    ))}
                </div>

                {adError && !checkMandatoryControl() && <div className='grc-error-msg text-danger'>{t('This field is required')}</div>}
                {adError && !checkTablebody() && <div>
                    <div className='grc-error-msg text-danger'>{t('Please add rows to selected controls')}</div></div>}
                {/* <Tabs
                    value={activeTab} onValueChange={onTabValueChange}>
                    <TabsList>
                        <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="tasks" direction='horizontal'>
                                {(provided) => (

                                    <div ref={provided.innerRef} className='flex gap-4' {...provided.droppableProps}>

                                        {selectedValues?.complainceControlIndex?.map((data, index) => (
                                            <TabsTrigger key={index} value={data.controlId}><Draggable
                                                key={data.controlId}
                                                draggableId={data.controlId.toString()}
                                                index={index}
                                            >
                                                {(provided) => (
                                                    <div
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        ref={provided.innerRef}
                                                    >
                                                        {controls.find((item) => item.controlId === data.controlId).controlName}

                                                    </div>
                                                )}
                                            </Draggable>
                                            </TabsTrigger>
                                        ))}
                                        {provided.placeholder}

                                    </div>

                                )}
                            </Droppable>
                        </DragDropContext>
                    </TabsList>
                </Tabs> */}
                <Tabs
                    value={activeTab}
                    onValueChange={onTabValueChange}>
                    <TabsList>

                        {selectedValues?.complainceControlIndex?.map((data, i) => {
                            return (
                                <TabsTrigger key={i} value={data.controlId} className='!text-menu'>{controls.find((item) => item.controlId === data.controlId).controlName}</TabsTrigger>
                            )
                        })}
                    </TabsList>
                    {
                        selectedValues?.complainceControlIndex?.map((data, i) => {
                            return (
                                <>
                                    {data.controlId === 1 && <BinaryQuestionTable selectedValues={selectedValues} setSelectedValues={setSelectedValues} inputValidation={inputValidation} activeTab={activeTab} controls={controls} control={control} data={selectedValues.binaryQuestions} errors={errors} onInputChangeTextArea={onInputChangeTextArea} onValueSelectChange={onValueSelectChange} handleAddControls={handleAddControls} handleDeleteControls={handleDeleteControls} i={i} />}
                                    {data.controlId === 2 && <FormsQuestionTable inputValidation={inputValidation} activeTab={activeTab} controls={controls} control={control} data={selectedValues.forms} errors={errors} onInputChangeTextArea={onInputChangeTextArea} onInputChange={onInputChange} handleAddControls={handleAddControls} handleDeleteControls={handleDeleteControls} i={i} formFileRef={formFileRef} />}
                                    {data.controlId === 3 && <ThresholdLimitQuestions inputValidation={inputValidation} trigger={trigger} setValue={setValue} activeTab={activeTab} selectedValues={selectedValues} onValueSelectChange={onValueSelectChange} controls={controls} control={control} data={selectedValues.thresholdLimits} errors={errors} onInputChangeTextArea={onInputChangeTextArea} onInputChange={onInputChange} handleAddControls={handleAddControls} handleDeleteControls={handleDeleteControls} />}
                                    {data.controlId === 4 && <ChecklistQuestions timeline={selectedValues.complainceTimeline.timeLine} handleDateChange={handleDateChange} inputValidation={inputValidation} activeTab={activeTab} selectedValues={selectedValues} onValueSelectChange={onValueSelectChange} controls={controls} control={control} data={selectedValues.checkLIst} errors={errors} onInputChangeTextArea={onInputChangeTextArea} onInputChange={onInputChange} handleAddControls={handleAddControls} handleDeleteControls={handleDeleteControls} />}
                                </>)
                        })
                    }
                </Tabs>
            </Card>
            <div className='w-full flex justify-end gap-5 pt-5'>
                <Button
                    variant='outline'
                    style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                    onClick={() => {
                        navigate(routePath + '/' + mandateType + '/' + regulationName + '?bodyType=' + bodyType + '&regulation=1' + '&status=' + selectedValues?.status + '&frequency=' + selectedValues?.complainceTimeline?.frequency + '&regulationId=' + selectedValues.regulationId)
                    }}
                >
                    {t('Cancel')}
                </Button>
                <div onClick={() => { setAdError(true) }}>
                    <Button onClick={handleSubmit(handleAddCompliance)} disabled={isSubmitting || isLoading}>{t('Submit')}</Button>
                </div>
            </div>
            <CreateRaciMatrixDialog tempRaciMatrix={tempRaciMatrix} isOpen={isDialogOpen} raciiMatrices={raciiMatrices} setRaciiMatrices={setRaciiMatrices} selectedValues={selectedValues} setSelectedValues={setSelectedValues} onCloseDialog={() => setIsDialogOpen(false)} onSave={handleSaveRaciMatrix} />
        </div>
    )
}

export default AddCompliance
